import React, { FC } from 'react';
import { Icon, Text } from 'view/atoms';
import { close } from 'static/icons/resizable';
import { ChipProps } from './Chip.model';
import * as S from './Chip.styles';

export const Chip: FC<ChipProps> = ({ label, icon, closeAction, children }) => {
  return children ? (
    <S.Chip>
      {icon && <Icon src={icon} />}
      <Text kind='small2' color='gray1'>
        {label}
      </Text>
      {children}
    </S.Chip>
  ) : (
    <S.Chip>
      {icon && <Icon src={icon} />}
      <Text kind='small2' color='gray1'>
        {label}
      </Text>
      {closeAction && (
        <S.CloseIcon src={close} onClick={closeAction} alt='close' />
      )}
    </S.Chip>
  );
};
